import { ModalBody, ModalFooter } from "@nextui-org/react";
import Button from "../../../Button/Button";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { closeModal } from "../../../../store/slices/unifiedBalanceSlice";
import styles from "./SuccessUnification.module.scss";
import success from "../../../../assets/images/icons/ui/states/success-inverted-filled-icon.svg";
import { useEffect } from "react";
import useScreenSize from "../../../../hooks/useScreenSize";

const SuccessUnification = () => {
  const dispatch = useAppDispatch();
  const {
    assessmentData: { assessment },
  } = useAppSelector((state) => state.unifiedBalance);
  const { bodyContainer, footerContainer, icon, modalFooterMobile } = styles;
  const { isMobile } = useScreenSize();

  useEffect(() => {
    if (!isMobile) return;
    const closeBtn = document.querySelector(
      '[aria-label="Close"]',
    ) as HTMLElement | null;
    if (!closeBtn) return;
    closeBtn.style.visibility = "hidden";
  }, [isMobile]);

  const getText = () => {
    switch (assessment.required_action) {
      case "NOTIFY_ALLARIA_MAS":
      case "DO_NOTHING":
      case "ASSIGN_ROLE_COLLABORATOR":
      case "CREATE_USER_IN_ALLARIA_MAS_WITH_COLLABORATOR_ROLE":
        return (
          <>
            <p>Te avisaremos por mail cuando esté lista.</p>
            <p>
              Vas a poder ver tus saldos unificados en la próxima apertura de
              mercado.
            </p>
          </>
        );

      case "CREATE_ACCOUNT_WITH_THIS_EMAIL_AS_OWNER":
      case "CREATE_ACCOUNT_OWNER_FOR_ALL_COOWNERS":
        return <p>Te avisaremos por mail cuando esté lista.</p>;
      default:
        return "";
    }
  };

  const getTitle = () => {
    switch (assessment.required_action) {
      case "NOTIFY_ALLARIA_MAS":
      case "DO_NOTHING":
      case "ASSIGN_ROLE_COLLABORATOR":
      case "CREATE_USER_IN_ALLARIA_MAS_WITH_COLLABORATOR_ROLE":
        return "Unificación en proceso";
      case "CREATE_ACCOUNT_WITH_THIS_EMAIL_AS_OWNER":
      case "CREATE_ACCOUNT_OWNER_FOR_ALL_COOWNERS":
        return "Apertura y unificación en proceso";
      default:
        return "";
    }
  };

  return (
    <>
      <ModalBody>
        <div className={bodyContainer}>
          <img src={success} className={icon} />
          <h2 className="mt-6">{getTitle()}</h2>
          <p className="mt-4">{getText()}</p>
        </div>
      </ModalBody>
      <ModalFooter
        className={isMobile ? modalFooterMobile : ""}
      >
        <div className={isMobile ? modalFooterMobile : footerContainer}>
          <Button
            variant="primary"
            text="Listo"
            onPress={() => dispatch(closeModal())}
            className={isMobile ? "w-full" : ""}
          />
        </div>
      </ModalFooter>
    </>
  );
};

export default SuccessUnification;
